import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { CurrentUserService } from '@services/auth/current-user.service';
import { resolveHomeRoute } from './home-route';

export const noAuthGuard = () => {
	const authService = inject(AuthService);
	const currentUserService = inject(CurrentUserService);
	const router = inject(Router);

	/**
	 * Protects public routes from authenticated users.
	 * Redirects to a protected route if the user is authenticated.
	 */
	if (authService.isAuthenticated()) {
		router.navigate([resolveHomeRoute(currentUserService)]);
		return false;
	}

	return true;
};
